import { useCallback, useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';

import { useApi } from 'services/api';
import useStore from 'services/store';
import log from 'services/log';
import { getConfiguredTimezone } from 'utils/datetime';

const selector = (state) => ({
  activeSensorsByProfile: state.searchQuery.activeSensorsByProfile,
});

const useDictionary = (searchType, context) => {
  const api = useApi();
  const { activeSensorsByProfile } = useStore(selector);
  const timezone = getConfiguredTimezone();

  const { data, error, isLoading } = useQuery({
    queryKey: ['search', 'dictionary', searchType, activeSensorsByProfile],
    queryFn: ({ signal }) =>
      api.get('/search/dictionary', {
        params: { timezone, context: context || activeSensorsByProfile, searchType },
        signal,
      }),
    enabled: !!searchType && activeSensorsByProfile !== undefined,
    staleTime: Infinity,
    select: (data) => {
      return searchType === 'O_SENSOR' ? data?.data?.properties : data;
    },
  });

  useEffect(() => {
    if (error) {
      log({
        type: 'info',
        origin: 'useDictionary',
        message: 'failed loading /search/dictionary',
        info: JSON.stringify(error),
      });
    }
  }, [error]);

  const getItemType = useCallback((key) => data?.[key]?.type, [data]);

  return { isLoading, data, error, getItemType };
};

export default useDictionary;
